import { useEffect, useState } from 'react';

export function useDeferredMount(delayMs = 2200) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const timer = window.setTimeout(() => setReady(true), delayMs);
    return () => window.clearTimeout(timer);
  }, [delayMs]);

  return ready;
}
